import React from 'react';

import { ScreenHead } from '../../ui/screen-parts.js';
import { Chip, Field, Panel, Empty, useFlash, readForm } from '../../ui/kit.js';
import { useBuilding, RESIDENT, day } from '../../state/building.js';

import RepairSink from '../../media/images/modules/repair-sink.jpg';

export const STATUS_TONE = { 'New': 'info', 'Assigned': 'warn', 'In progress': 'warn', 'Done': 'ok' };

const CATEGORIES = ['Plumbing', 'Electrical', 'HVAC', 'Appliance', 'Doors & locks', 'Other'];

/* Service Requests / Work Orders, the resident's half. What is submitted
   here is the same record maintenance sees on its board. */
function ServiceRequestsScreen() {
    const { workOrders, add } = useBuilding();
    const [flash, notify] = useFlash();
    const mine = workOrders.filter(w => w.unit === RESIDENT.unit);

    const submit = event => {
        const values = readForm(event, ['title']);
        if (!values) return notify('Tell us what needs fixing first.');

        add('workOrders', {
            unit: RESIDENT.unit,
            title: values.title,
            category: values.category,
            priority: values.urgent ? 'High' : 'Normal',
            status: 'New',
            assignee: '',
            opened: day(0),
            entry: Boolean(values.entry),
            note: values.note
        });
        notify('Request sent. Maintenance has it on their board now.');
    };

    return (
        <div className="screen-content">
            <ScreenHead eyebrow="Service requests" title="Something need fixing?" />
            {flash}

            <div className="banner">
                <img src={RepairSink} alt="" />
                <p className="banner__caption">Report it once and maintenance sees it on their board right away.</p>
            </div>

            <div className="split">
                <Panel as="form" className="panel--accent" onSubmit={submit}>
                    <h4>New request</h4>
                    <div className="form">
                        <Field label="What is wrong" wide>
                            <input name="title" className="form-control" placeholder="e.g. Bathroom sink is clogged" />
                        </Field>
                        <Field label="Category">
                            <select name="category" className="form-control" defaultValue="Plumbing">
                                {CATEGORIES.map(c => <option key={c}>{c}</option>)}
                            </select>
                        </Field>
                        <Field label="Unit">
                            <input className="form-control" value={RESIDENT.unit} readOnly />
                        </Field>
                        <Field label="Details" wide>
                            <textarea name="note" className="form-control" rows="3" placeholder="Anything the technician should know" />
                        </Field>
                        <label className="field field--wide check">
                            <input type="checkbox" name="entry" defaultChecked style={{ width: 'auto' }} />
                            <span>Staff may enter if I am not home</span>
                        </label>
                        <label className="field field--wide check">
                            <input type="checkbox" name="urgent" style={{ width: 'auto' }} />
                            <span>This is urgent (leak, no power, no AC)</span>
                        </label>
                        <button type="submit" className="btn btn-primary">Submit request</button>
                    </div>
                </Panel>

                <div className="stack">
                    <h4>Your requests</h4>
                    {mine.length === 0 ? <Empty>No open requests.</Empty> : (
                        <ul className="rows">
                            {mine.map(w => (
                                <li className="row" key={w.id}>
                                    <div className="row__main">
                                        <span className="row__title">{w.title}</span>
                                        <span className="row__meta">
                                            {w.category} · opened {w.opened}{w.assignee ? ` · ${w.assignee}` : ''}
                                        </span>
                                    </div>
                                    <div className="row__end">
                                        {w.priority === 'High' && <Chip tone="alert">Urgent</Chip>}
                                        <Chip tone={STATUS_TONE[w.status]}>{w.status}</Chip>
                                    </div>
                                </li>
                            ))}
                        </ul>
                    )}
                </div>
            </div>
        </div>
    );
}

export default ServiceRequestsScreen;
